/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_2_VInputs */

const en_cp_fact_2_v = /** @type {(inputs: Cp_Fact_2_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR 299k`)
};

const id_cp_fact_2_v = /** @type {(inputs: Cp_Fact_2_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 299 rb`)
};

/**
* | output |
* | --- |
* | "IDR 299k" |
*
* @param {Cp_Fact_2_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_2_v = /** @type {((inputs?: Cp_Fact_2_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_2_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_2_v(inputs)
	return en_cp_fact_2_v(inputs)
});